import { Component, OnInit } from '@angular/core';

import { MasksService } from '../masks.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  imagesize = 'medium';
  attendee = '';
  category = '';
  rank = '';
  deepdive = false;
  selected;
  selectedIndex;

  maskFilter = '';
  masksList = [];

  imageLoading = false;

  constructor(
    public masks: MasksService,
  ) { }

  ngOnInit(): void {
  }

  rotateSize() {
    if (this.imagesize === 'small') {
      this.imagesize = 'medium';
    } else if (this.imagesize === 'medium') {
      this.imagesize = 'large';
    } else if (this.imagesize === 'large') {
      this.imagesize = 'small';
    } else if (this.imagesize === 'tiny') {
      this.imagesize = 'small';
    }
  }

  filtered(mask: any): boolean {
    let filtered = false;

    if (this.deepdive) {
      if (!mask.reviewurl) {
        filtered = true;
      }
    }

    if (this.attendee?.length) {
      for (let attribute of mask.attributes) {
        if (attribute.trait_type === 'Attendee Type') {
          if (attribute.value !== this.attendee) {
            filtered = true;
          }
        }
      }
    }

    if (this.category?.length) {
      for (let attribute of mask.attributes) {
        if (attribute.trait_type === 'Category') {
          if (attribute.value !== this.category) {
            filtered = true;
          }
        }
      }
    }

    if (this.rank?.length) {
      let rankfiltered = true;
      for (let attribute of mask.attributes) {
        if (attribute.trait_type === 'Rank') {
          if (attribute.value === this.rank) {
            rankfiltered = false;
          }
        }
      }
      if (rankfiltered) {
        filtered = true;
      }
    }


    return filtered;
  }

  clearfilters() {
    this.attendee = '';
    this.category = '';
    this.rank = '';
  }

  getMasks(): any[] {
    let masks: any[] = [];
    const maskFilter = `${this.attendee}${this.category}${this.rank}${this.deepdive}`;

    if (this.maskFilter === maskFilter && this.masksList?.length) {
      return this.masksList;
    } else {
      for (let mask of this.masks.get()) {
        if (!this.filtered(mask)) {
          masks.push(mask);
        }
      }
      if (this.deepdive) {
        console.log('sort deep drive')
        masks.sort((a, b) => a.category.localeCompare(b.category));
      }
      this.maskFilter = maskFilter;
      this.masksList = masks;
    }

    return this.masksList;
  }

  selectedMaskBack() {
    this.imageLoading = true;
    this.selectedIndex -= 1;
    this.selected = this.getMasks()[this.selectedIndex];
  }

  selectedMaskForward() {
    this.imageLoading = true;
    this.selectedIndex += 1;
    this.selected = this.getMasks()[this.selectedIndex];
  }

  imageLoaded() {
    this.imageLoading = false;
    console.log('image loaded')
  }
}
